import React from 'react'
import PropTypes from 'prop-types'
import { FromSelectLabelWrapper, FromSelectLabel, FromSelectStyled, FromSelectError } from './styled'

const FromSelect = ({ label, placeholder, name, onChange, value, error, options, green, maxWidth, disabled, noMargin }) => {

  const renderPlaceholder = placeholder => {
    if (placeholder) {
      if (placeholder !== '' && placeholder !== 'placeholder') {
        return <option value="" disabled>{placeholder}</option>
      }
    }
  }

  return (
    <FromSelectLabelWrapper
      error={error}
      maxWidth={maxWidth}
      disabled={disabled}
      noMargin={noMargin}
    >
      {
        label && 
        <FromSelectLabel>{label}</FromSelectLabel>
      }
      <FromSelectStyled
        name={name}
        onChange={onChange}
        value={value}
        green={green}
      >
        {renderPlaceholder(placeholder)}
        {options && options.map((option, index) => <option key={index} value={option.value}>{option.label}</option>)}
      </FromSelectStyled>
      {error && <FromSelectError>{error}</FromSelectError>}
    </FromSelectLabelWrapper>
  )

}

FromSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool
}

FromSelect.defaultProps = {
  label: '',
  placeholder: '',
  name: 'input',
  onChange: () => { },
  value: '',
  error: '',
  options: [
    { value: '', label: 'Label' }
  ],
  disabled: false
}

export default FromSelect
